module.exports = __webpack_public_path__ + "media/banner.b5fc078e.mp4";